import request from "@/utils/request";

export function getUserInfo(data) {
  return request({
    url: "/xiaowei/order/report",
    method: "post",
    params:data
  });
}

